import { fromJS } from 'immutable'

import { SHOW_CONFIRM, HIDE_CONFIRM } from './../../constants'

const initialState = fromJS({
//   status: false,
//   modalType: List(),
})

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_CONFIRM:
      return state
        .set('modalStatus', action.modalStatus)
        .set('modalType', action.modalType)
        .set('modalMessage', action.modalMessage)
    case HIDE_CONFIRM:
      return state
        .delete('modalStatus')
        .delete('modalType')
        .delete('modalMessage')
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal/confirm-reducer.js